import React from 'react';
import { SplitClient, SplitTreatments } from '@splitsoftware/splitio-react';
import CONSTANTS from 'src/store/constants';
import { Ubac } from 'src/containers';
import { GridWrapper, Message } from 'src/components';

/* eslint-disable react/prop-types */

function ViewModelFeatureToggleOn(props) {
  return <GridWrapper {...props} />;
}

function ViewModelFeatureToggleOff(props) {
  return (
    <Ubac
      users={CONSTANTS.ENG_TEAM}
      fallback={
        <Message
          type="info"
          text="No data"
          cta={{
            text: 'Refresh',
            onClick: () => {},
          }}
        />
      }
    >
      <GridWrapper {...props} />
    </Ubac>
  );
}

export function ViewModelFeatureToggle({ tenant, ...rest }) {
  return (
    <SplitClient splitKey={tenant}>
      <SplitTreatments names={[CONSTANTS.SPLIT_NAMES.CAN_VIEW_THINKALIKE_MODELS]}>
        {({ treatments, isReady }) => {
          if (!isReady) {
            return null;
          }
          if (treatments[CONSTANTS.SPLIT_NAMES.CAN_VIEW_THINKALIKE_MODELS].treatment === 'on') {
            return <ViewModelFeatureToggleOn {...rest} />;
          }
          return <ViewModelFeatureToggleOff {...rest} />;
        }}
      </SplitTreatments>
    </SplitClient>
  );
}
